/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentConfigurationDto } from '../../models/current-configuration-dto';

export interface GetCurrentConfiguration$Params {
}

export function getCurrentConfiguration(http: HttpClient, rootUrl: string, params?: GetCurrentConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentConfigurationDto>> {
  const rb = new RequestBuilder(rootUrl, getCurrentConfiguration.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentConfigurationDto>;
    })
  );
}

getCurrentConfiguration.PATH = '/v0/currentConfiguration';
